export default {
    parent: 'ApplicationLayout',
    template: `
        <header-survey class="header-wrapper header-fixed" />
        <div class="col00 small ">
            <ui-view class="body-wrapper" />
        </div>
        <footer class="footer-wrapper" />
    `,
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/layouts/survey/index.js